export default "__VITE_ASSET__ZSxaryqE__"